import store from 'storejs';
import {useController} from "react-hook-form";
import RadioGroup from "./RadioGroup";
import {RECURRING} from "../Constants/PaymentTypes";

const RecurringPayment = ({control, name}) => {
    const {
        field: {onChange, onBlur, value},
        fieldState: {error},
    } = useController({
        name,
        control,
        rules: {required: true},
    })

    const cards = store(RECURRING);

    return <>
        <RadioGroup onBlur={onBlur} onChange={onChange} value={value} items={cards} error={error} name={name}/>
    </>
}

export default RecurringPayment;